// #565: Welche Darstellung gilt, und wie sie auf die Seite kommt.
//
// Wirksam ist die eigene Wahl aus den Benutzer-Einstellungen (#564,
// Schlüssel `darstellung`), sonst die Vorgabe der Installation (Reiter
// „Features“, /api/config/features), sonst Modern. Angewendet wird sie als
// `data-theme` an <html>; themes/kaycee.css macht den Rest, ohne Neuladen.
// Das Cookie `uiTheme` spiegelt sie für das erste Bild beim nächsten Laden
// (public/darstellung-vorab.js), sonst blitzt dort erst die Vorgabe auf.

export const DARSTELLUNGEN = ['modern', 'klassisch'];
const COOKIE = 'uiTheme';

/**
 * @param {{ darstellung?: string } | null} einstellungen  Benutzer-Einstellungen
 * @param {string | undefined} vorgabe  Vorgabe der Installation
 */
export function wirksameDarstellung(einstellungen, vorgabe) {
  const eigene = einstellungen && einstellungen.darstellung;
  if (DARSTELLUNGEN.includes(eigene)) return eigene;
  return DARSTELLUNGEN.includes(vorgabe) ? vorgabe : 'modern';
}

export function wendeDarstellungAn(darstellung) {
  const wert = DARSTELLUNGEN.includes(darstellung) ? darstellung : 'modern';
  try {
    const html = document.documentElement;
    if (html.getAttribute('data-theme') !== wert) html.setAttribute('data-theme', wert);
    const ablauf = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${COOKIE}=${wert};expires=${ablauf};path=/;SameSite=Lax`;
    // Die Farbe der Browserleiste steht als Token in themes/kaycee.css
    const meta = document.querySelector('meta[name="theme-color"]');
    const farbe = getComputedStyle(html).getPropertyValue('--kc-ticket-theme-color').trim();
    if (meta && farbe) meta.setAttribute('content', farbe);
  } catch (_) {
    // ohne DOM (Tests ohne jsdom) gibt es nichts anzuwenden
  }
  return wert;
}
